var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-27.556 -10.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(27.556 10.336)",
    fill: "#f0f1f4",
    stroke: "#cad0d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "mobile_1_",
    "data-name": "mobile (1)",
    d: "M8.253,0A1.229,1.229,0,0,0,7,1.21V26.792A1.229,1.229,0,0,0,8.253,28H22.378a1.227,1.227,0,0,0,1.251-1.208V1.21A1.227,1.227,0,0,0,22.378,0H8.253ZM14,.886h2.625v.863H14V.886ZM8.752,2.624H21.879v21H8.752v-21ZM15.333,24.5A1.313,1.313,0,1,1,14,25.815a1.322,1.322,0,0,1,1.33-1.313Z",
    transform: "translate(44.557 28.335)",
    fill: "#304669"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.139c3069ed5ffff95902e93f3ec1f75a.svg";
export { ForwardRef as ReactComponent };